import { getExcludeValues, mergeMultiItemValues } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import * as mobx from 'mobx';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { getMenuValues as getGroupMenuValues } from '@src/slide/application/service/menu-manager/menu-values/group';
import type { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { getAllImage, getElementMenuValues } from './element-menu-values-getter';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { setImageValue } from './element-menu-values-setter';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: IMultiplyModel): { [key: string]: any } {
    if (model.selectedModels) {
        // 聚合子元素的菜单值获取，有缓存优先读取缓存
        const mergeMenuValuesCache = getMenuManager()?.mergeMenuValuesCacheMap.get(model);
        if (mergeMenuValuesCache) {
            return mergeMenuValuesCache;
        }
        const valuesArray: Array<any> = [];
        mobx.transaction(() => {
            model.selectedModels.forEach((child) => {
                if (child.type === UIModelType.GROUP) {
                    valuesArray.push(getGroupMenuValues(child as IGroupModel));
                } else if (child.type !== UIModelType.TABLE) {
                    valuesArray.push(getElementMenuValues(child));
                }
            });
            // 和上面的逻辑有些许不同，字体大小调节按钮额外判断，model 均是 text 时才有效
            if (model.selectedModels.every(model => model.type === UIModelType.SHAPE)) {
                valuesArray.push({ [ActionType.FONTSIZE_INCREASE]: undefined });
                valuesArray.push({ [ActionType.FONTSIZE_UP]: undefined });
            }
        });
        const mergeValues = mergeMultiItemValues(valuesArray, getExcludeValues(model.selectedModels));

        // 存在非table的情况下，传入一个占位让PARAGRAPH_MORE能显示
        if (model.selectedModels.find(child => child.type !== UIModelType.TABLE)) {
            mergeValues[ActionType.PARAGRAPH_MORE] = 1;
        }
        // 存在图片或者图片填充的情况下，取第一个model的值进行显示
        const [imageModel] = getAllImage(model);
        if (imageModel) {
            setImageValue(mergeValues, imageModel as IShapeModel | IPictureModel);
        }
        return mergeValues;
    }
    return {};
}

function getMenuManager(): IMenuManager | undefined {
    return (AppServiceProvider.getInstance()
        .getAppServices() as IEditorAppServices).editableServiceLayer?.menuManager;
}
